<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xl3 lg4 md5 sm6>
        <v-layout row wrap justify-center>
          <v-flex xs5 class="mb-4">
            <v-img
              contain
              min-width="120px"
              :src="require('@/assets/allsight-logo1-light.png')"
            ></v-img>
          </v-flex>
          <v-flex>
            <v-card class="elevation-12 mb-12">
              <v-layout>
                <v-flex>
                  <v-card-title primary-title>
                    <v-layout row justify-center>
                      <v-flex md6>
                        <object
                          width="100%"
                          :data="require('@/assets/elsight-light-logo3.svg')"
                        ></object>
                      </v-flex>
                      <v-flex>
                        <h4 class="display-1 primary--text text-center">
                          {{ $t("modules.forgotPassword.title") }}
                        </h4>
                      </v-flex>
                    </v-layout>
                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-card-text>
                <v-form
                  v-if="!submitted"
                  @keyup.native.enter="forgot_password()"
                >
                  <v-text-field
                    required
                    clearable
                    validate-on-blur
                    :label="$t('modules.forgotPassword.email')"
                    v-model="credentials.email"
                    prepend-icon="mdi-email"
                    id="forgotPassword__form-email"
                  ></v-text-field>
                  <v-text-field
                    required
                    clearable
                    validate-on-blur
                    :label="$t('modules.forgotPassword.environment')"
                    v-model="credentials.environment_name"
                    prepend-icon="mdi-domain"
                    id="forgotPassword__form-environment"
                  ></v-text-field>
                  <v-card-actions>
                    <v-btn
                      :loading="loading"
                      @click="forgot_password()"
                      block
                      color="primary"
                      id="forgotPassword__form-button"
                      >{{ $t("modules.forgotPassword.submitOperation") }}</v-btn
                    >
                  </v-card-actions>
                </v-form>
                <div v-if="submitted">
                  <span>
                    {{ $t("modules.forgotPassword.emailWillBeSent") }}
                  </span>
                  <b>{{ credentials.email }}.</b>
                  <br />
                  <br />
                  <span>{{ $t("modules.forgotPassword.ifNoUserFound") }} </span>
                  <br />
                  <br />
                  <span>{{
                    $t("modules.forgotPassword.makeSureUserHaveThisEmail")
                  }}</span>
                  <br />
                  <br />
                  <span>{{
                    $t("modules.forgotPassword.searchForElsight")
                  }}</span>
                  <br />
                  <br />
                  <v-btn
                    :loading="loading"
                    @click="back_to_login_page()"
                    id="goBackToLogin__form-button"
                  >
                    <v-icon>mdi-keyboard-backspace</v-icon>
                    {{
                      $t("modules.forgotPassword.goBackToLoginPageOperation")
                    }}
                  </v-btn>
                </div>
              </v-card-text>
              <v-snackbar
                multi-line
                color="error"
                v-model="error.general.shown"
                :timeout="error.general.timeout"
                id="login__snackbar-error-general0"
              >
                {{ $t("modules.login.error.general") }}
                <template v-slot:action="{ attr }">
                  <v-btn
                    text
                    @click="error.general.shown = false"
                    v-bind="attr"
                  >
                    {{ $t("modules.login.closeOperation") }}
                  </v-btn>
                </template>
              </v-snackbar>
              <v-snackbar
                multi-line
                color="error"
                v-model="error.credentials.shown"
                :timeout="error.general.timeout"
                id="login__snackbar-error-credentials"
              >
                {{ $t("modules.login.error.credentials") }}
                <template v-slot:action="{ attr }">
                  <v-btn
                    text
                    @click="error.credentials.shown = false"
                    v-bind="attr"
                  >
                    {{ $t("modules.login.closeOperation") }}
                  </v-btn>
                </template>
              </v-snackbar>
              <v-snackbar
                multi-line
                color="error"
                v-model="error.environment.shown"
                :timeout="error.general.timeout"
                id="login__snackbar-error-environment"
              >
                {{ $t("modules.login.error.environment") }}
                <template v-slot:action="{ attr }">
                  <v-btn
                    text
                    @click="error.environment.shown = false"
                    v-bind="attr"
                  >
                    {{ $t("modules.login.closeOperation") }}
                  </v-btn>
                </template>
              </v-snackbar>
              <v-snackbar
                multi-line
                color="error"
                v-model="error.general.shown"
                :timeout="error.general.timeout"
                id="login__snackbar-error-general"
              >
                {{ $t("modules.login.error.general") }}
                <template v-slot:action="{ attr }">
                  <v-btn
                    text
                    @click="error.general.shown = false"
                    v-bind="attr"
                  >
                    {{ $t("modules.login.closeOperation") }}
                  </v-btn>
                </template>
              </v-snackbar>
              <v-snackbar
                multi-line
                color="error"
                v-model="error.iderror.shown"
                :timeout="error.iderror.timeout"
                id="login__snackbar-error-iderror"
              >
                {{ $t("error.idNotFound") }}
                <template v-slot:action="{ attr }">
                  <v-btn
                    text
                    @click="error.iderror.shown = false"
                    v-bind="attr"
                  >
                    {{ $t("modules.login.closeOperation") }}
                  </v-btn>
                </template>
              </v-snackbar>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import util, {
  UserCredentialsError,
  UserEnvironmentError
} from "@/modules/login/util";

import { IdNotFoundError } from "@/utils/error";
export default {
  name: "ForgotPasswordPage",

  data() {
    return {
      submitted: false,
      loading: false,
      credentials: {
        email: "",
        environment_name: ""
      },
      error: {
        credentials: {
          shown: false,
          timeout: 0
        },
        environment: {
          shown: false,
          timeout: 0
        },
        general: {
          shown: false,
          timeout: 0
        },
        iderror: {
          shown: false,
          timeout: 0
        }
      }
    };
  },
  created() {
    if (this.$store.state.login.isLoggedIn === true) {
      this.$router.push({ name: "home" });
    }
  },

  methods: {
    forgot_password() {
      this.loading = true;
      this.error.credentials.shown = false;
      this.error.environment.shown = false;
      this.error.general.shown = false;

      const credentials = {
        email: this.credentials.email,
        environment_name: this.credentials.environment_name
      };

      this.$store
        .dispatch("forgotPassword/forgot_password", credentials)
        .then(response => {
          this.submitted = true;
        })
        .catch(error => {
          if (error instanceof UserCredentialsError) {
            this.error.credentials.shown = true;
          } else if (error instanceof UserEnvironmentError) {
            this.error.environment.shown = true;
          } else if (error instanceof IdNotFoundError) {
            this.error.iderror.shown = true;
          } else {
            this.error.general.shown = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    back_to_login_page() {
      this.$router.push({ name: "login" });
    }
  }
};
</script>
